export const EVENT = 'event';
export const EVENT_REAL = 'event_value';
export const UNIQUE_EVENT = 'unique';
export const UNIQUE_EVENT_REAL = 'unique_value';
export const SESSION = '__SESSION__';
export const REVENUE = '__REVENUE__';
export const NA_VALUE = 'N/A';
export const CONTROL_GROUP_RANGE = 100;
export const AUTOCOMPLETE_EVENT_SELECT = 'event-dropdown';
export const SESSION_EVENT = { label: 'Session', value: '__SESSION__' };

export const ROWS_DATA_KEYS = {
    GROUP_SIZE: 'groupSize',
    EVENT_COUNT: 'eventCount',
    ENGAGEMENT_RATE: 'engagementRate',
    ENGAGEMENT_INCREMENTALITY: 'engagementIncrementality',
    UNIQUE_EVENT_COUNT: 'uniqueEventCount',
    UNIQUE_CONVERSION_RATE: 'uniqueConversionRate',
    UNIQUE_INCREMENTALITY: 'uniqueIncrementality',
    INCREMENTALITY_REVENUE: 'incrementalityRevenue',
    TOTAL_REVENUE: 'totalRevenue',
};

export const REVENUE_KEY_ROWS = [ROWS_DATA_KEYS.INCREMENTALITY_REVENUE, ROWS_DATA_KEYS.TOTAL_REVENUE];

export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
});

export const PercentageFormatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

export const UPLIFTS_ICON_NAMES = {
    UP: 'trending-up-2',
    DOWN: 'trending-down-2',
    FORK: 'arrow-fork',
};
